/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, centerAbsolutely, imageTypes, animations, backgrounds } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// REDEEM STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    uniquecontent: {
        width: '100%',
        height: '100%',
    	'& .contentindicator, .pointindicator': {
    		display: 'none'
    	},
    	'& .frame.type-redeem': {
    		position: 'relative'
    	},
    	'& .background': {
    		'& .fade': {
    			background: `${backgrounds.standout} !important`
    		}
	    },
    	'& .redeem': {
	    	textAlign: 'center',
	        width: '100%',
            '& .giftcard': {
                // width: pxToEm(107),
                // height: pxToEm(67),
                marginBottom: pxToEm(15),
				'&.amazonstars': {
                    marginBottom: pxToEm(-7)
                },
                '&.genericstars': {
                    marginBottom: pxToEm(-7)
                }
            }
	    }
    }
};